import React, { useContext, useEffect, useState } from 'react';

import { useNavigate} from "react-router-dom";

import CanvasJSChart from "./ReactCanvasJSChart";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { getPanelHeader } from "./DashboardPanelFunctions";
import { getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import { getProviderSectionCompletionStats} from "root/DataFunctions/ChartFns";
import GlobalContext, { useGlobalContext } from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const DashboardPanelProviderCompletionBarStats= ( {provider_id, panelStyle='panel-default', survey_type, title='Title', id}) =>
{
	const [ data, setData ] = useState ( { loading: true, data: [], dataPoints: []})

	const navigate = useNavigate() ;

	const { getCustomObject } = useGlobalContext() ;

	useEffect(() =>
	{
		getServerData() ;
	}, []);

	const onRowClick = ( e ) =>
	{
		const url = '/school/current/year/current/section/' + e.dataPoint.id  ;

		navigate(url);
	}

	const getServerData = () =>
	{
		getProviderSectionCompletionStats(provider_id, 'current', survey_type, (response) =>
		{
			const reportData = getDataFromResponse(response);


			const p1 = reportData.map ((row) =>
			{
				const value = +(row.done) ;
				const label1 = row.section_name_abbrev === null ?  ( 'S ' + row.table_section_id ) : row.section_name_abbrev ;

				return { label: label1,
						 y: value,
						 id: row.provider_table_section_id }
			}) ;

			const p2 = reportData.map ((row) =>
			{

				const value = +(row.total) - +(row.done) ;
				const label2 = row.section_name_abbrev === null ? ( 'S ' + row.table_section_id ) : row.section_name_abbrev ;

				return { label: label2,
						 y: value,
						id: row.provider_table_section_id }
			}) ;

			const graphData = [
				{
					type: "stackedColumn",
					name: "Submitted",
					showInLegend: false,
					color: "#92D050",
					click: onRowClick,
					cursor: 'pointer',
					dataPoints: p1,
				},
				{
					type: "stackedColumn",
					name: "Not Submitted",
					showInLegend: false,
					color: "#e8e7e2",
					click: onRowClick,
					cursor: 'pointer',
					dataPoints: p2
				},
			] ;

			setData({loading: false, dataPoints: graphData, data: reportData }) ;
		});

	}

	const formPanel = () =>
	{
		const interval = getCustomObject( ConfigOptions.GRAPH_INTERVAL ) ;

		let options = {
			animationEnabled: true,
			height: 400,
			backgroundColor: "#FAFBFD",

			title: {
				text: "",
				fontColor: '#333',
				fontSize: 18,
				fontWeight: 'lighter',
				fontFamily: 'tahoma',
				padding: 20
			},
			axisX:{
				title:'',
				titleFontColor: '#333',
				titleFontSize: 14,
				//titleFontWeight: 'lighter',
				titleFontFamily: 'tahoma',
				margin: 50,
				tickLength: 0
			},
			axisY: {
				title: "Questions",
				interlacedColor: "white",
				interval: interval,
				titleFontSize: 14,
				gridColor: "white",
				titleFontFamily: 'tahoma',
				tickLength: 0
			},
			legend: {
				verticalAlign: "center",
				horizontalAlign: "right",
				reversed: true,
				cursor: "pointer",
				fontSize: 16,
			},
			toolTip: {
				shared: true
			},

			data: data.dataPoints
		};

		return (
			<div className={'panel ' + panelStyle}>
				{ getPanelHeader({ title: title })}
				<div className='panel-body'>
					<CanvasJSChart id='chartCareersAdvice' options={options} uniqueId={'canvas'+ id}/>
				</div>
			</div>
		)
	}

	if ( data.loading === true )
	{
		return <SpinnerDiv/>
	}
	else
	{
		return formPanel() ;
	}

};

export default DashboardPanelProviderCompletionBarStats;

